import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Keys, StorageService} from '../../../service/storage.service';
import {LoginInteractor} from '../../../interactors/login.interactor';

export interface DialogData {
    otp: number;
    loginId: string;
    phoneNumber: string;
}

@Component({
    selector: 'app-pan-already-present-pop-up',
    templateUrl: './pan-already-present-prompt.component.html',
    styleUrls: ['./pan-already-present-prompt.component.css']
})
export class PanAlreadyPresentPromptComponent implements OnInit {
    public otpErrorMessage: string;
    public isOtpResent = false;
    private readonly storageService: StorageService;
    private readonly loginInteractor: LoginInteractor;

    constructor(public dialogRef: MatDialogRef<PanAlreadyPresentPromptComponent>,
                @Inject(MAT_DIALOG_DATA) public data: DialogData,
                storageService: StorageService, loginInteractor: LoginInteractor) {
        dialogRef.disableClose = true;
        this.storageService = storageService;
        this.loginInteractor = loginInteractor;
    }

    ngOnInit(): void {
        this.disableResendOtpFor();
    }

    async onSubmit(otp: number): Promise<any> {
        const loginRequestId = this.storageService.getItem(Keys.LOGIN_TOKEN);
        try {
            const user = await this.loginInteractor.verifyPassword(loginRequestId, otp.toString());
            this.dialogRef.close(user);
        } catch (error) {
            if (error.status === 401) {
                this.isOtpResent = true;
                this.otpErrorMessage = 'Please provide a valid OTP';
            } else if (error.status === 429) {
                this.isOtpResent = true;
                this.otpErrorMessage = 'Please generate another OTP and try again';
            } else {
                throw error;
            }
        }
    }

    async resendOtp(): Promise<any> {
        try {
            const {id: token} = await this.loginInteractor.requestLogIn(this.data.loginId);
            this.storageService.saveItem(Keys.LOGIN_TOKEN, token);
            this.isOtpResent = false;
        } catch (error) {
            if (error.status === 429) {
                this.isOtpResent = true;
                this.otpErrorMessage = 'You have requested for the verification code too many times. Please wait for some time before trying again.';
            }
        } finally {
            this.disableResendOtpFor();
        }


    }

    private disableResendOtpFor() {
        setTimeout(() => this.isOtpResent = true, 30 * 1000);
    }
}
